<template>
	<div class="categorias-principais">
		<button class="toggle-categorias" type="button" data-toggle="categoria">
			<span class="only-desk"><i class="fa fa-bars"></i> Categorias</span>
			<span class="only-mob"><i class="fa fa-arrow-left"></i> Voltar</span>
		</button>

		<div class="categorias">
			<ul class="principais">
				<li v-for="principal in categorias.principais">
					<a :href="principal.link"> {{principal.text}} </a>
				</li>

				<li v-for="fixas in categorias.fixas">
					<a :href="fixas.link"> {{fixas.text}} </a>
				</li>
			</ul>
			<ul class="categorias-restantes">
				<li v-for="restantes in categorias.restantes">
					<a :href="restantes.link"> {{restantes.text}} </a>
				</li>
			</ul>
		</div>

		<div class="categoria-desk">
			<div class="brand">
				<img src="assets/images/logo.png" alt="logo TIVI" class="img-fluid">
			</div>

			<ul>
				<li v-for="principal in categorias.principais">
					<a :href="principal.link"> {{principal.text}} </a>
				</li>

				<li v-for="fixas in categorias.fixas">
					<a :href="fixas.link"> {{fixas.text}} </a>
				</li>

				<li v-for="restantes in categorias.restantes">
					<a :href="restantes.link"> {{restantes.text}} </a>
				</li>
			</ul>

			<div class="redes-sociais">
				<p>NOS SIGA NAS MÍDIAS SOCIAIS</p>

				<a :href="midia.link" v-for="midia in midias" :class="midia.class" :title="midia.title"></a>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	name: 'CategoriasTopo',
	props: [
		'categorias',
		'midias'
	]
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/Topo/CategoriasTopo.vue